<template>
  <div class="Partners">
    <Headers></Headers>
    <div class="banner"
         style="background: url(/static/banner/banner1.jpg) center">
      <div class="box">
        <div class="left"></div>
        <div class="container">
          <div class="title">合作伙伴</div>
          <div class="entitle">Partners</div>
        </div>
        <div class="right"></div>
      </div>
    </div>
    <div class="listbox">
      <div class="container">
        <div class="list"
             v-if="list.length > 0">
          <a :href="item.link_url"
             v-for="(item, index) in list"
             :key="index">
            <div class="img">
              <img :src="item.link_image"
                   alt="" />
            </div>
            <div class="title">{{ item.link_name }}</div>
          </a>
        </div>
        <unllimg v-else></unllimg>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Headers from '@/components/header/header.vue'
import Footer from '@/components/footer/footer.vue'
import unllimg from '@/components/unllimg/unllimg.vue'
import service from './Partners'
import { setmeta } from '@/assets/js/setmeta'

export default {
  name: 'Partners',
  mixins: [setmeta],
  data () {
    return {
      pagesize: 6,
      total: 0,
      page: 1,
      list: []
    }
  },
  components: {
    Headers,
    Footer,
    unllimg
  },
  methods: {},
  created () {
    this.setMetaConfig({
      web_title: `合作伙伴-${this.$env.TITLE}`
    })
    service.getLinksList(this)
  }
}
</script>

<style lang="scss" scoped>
@import './Partners';
@import '../../assets/scss/base';
</style>



// WEBPACK FOOTER //
// src/views/Partners/Partners.vue